export const API_ROOT = 'https://lockers-api-erp.vacway.es/v1/'
export const GMAPS_KEY = 'AIzaSyD39iuEVHCssLGXeFFQsFOMHSDnbaQjxao'
